module.exports = __webpack_public_path__ + "media/wan25-demo.e36367bb.mp4";